import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminOrderContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;

  @jsonMember(Boolean)
  public readonly canBeRefunded!: boolean;

  @jsonMember(Boolean)
  public readonly canBeCancelled!: boolean;

  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeCompleted!: boolean;

  @jsonMember(Boolean)
  public readonly canBeMarkAsPaid!: boolean;
}
